import React from "react";

import {Button} from "@pg-design/button-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

interface IProps {
    phoneNumber: string;
    onClickPhoneNumber?: () => void;
    className?: string;
}

export const PhoneButton = (props: IProps) => {
    const {phoneNumber, onClickPhoneNumber} = props;

    return (
        <Button
            variant="filled_primary"
            href={!!phoneNumber ? `tel:+${phoneNumber.replace(/ /g, "")}` : undefined}
            onClick={onClickPhoneNumber}
            className={props.className}
        >
            {!!phoneNumber ? phoneNumberFormat(phoneNumber) : "BRAK DANYCH KONTAKTOWYCH"}
        </Button>
    );
};
import React from "react";

import {Button} from "@pg-design/button-module";
import {phoneNumberFormat} from "@pg-mono/string-utils";

interface IProps {
    phoneNumber: string;
    onClickPhoneNumber?: () => void;
    className?: string;
}

export const PhoneButton = (props: IProps) => {
    const {phoneNumber, onClickPhoneNumber} = props;

    return (
        <Button
            variant="filled_primary"
            href={!!phoneNumber ? `tel:+${phoneNumber.replace(/ /g, "")}` : undefined}
            onClick={onClickPhoneNumber}
            className={props.className}
        >
            {!!phoneNumber ? phoneNumberFormat(phoneNumber) : "BRAK DANYCH KONTAKTOWYCH"}
        </Button>
    );
};
